<template>
    <div 
        class="w-full p-4 border rounded-xl cursor-pointer transition-all duration-200"
        :data-cy="`btn_financial_health_quiz_choice_${value}`"
        :class="[
            isSelected 
                ? 'border-a-blue-0064ff bg-a-blue-f2f5ff' 
                : 'border-a-gray-d9d9d9 bg-white hover:border-a-gray-999999'
        ]"
        @click="selectChoice"
    >
        <div class="flex items-center gap-3"> 
            <!-- Choice Text -->
            <p class="flex-1 text-16 leading-relaxed text-a-black" :class="fontClass" v-html="formattedLabel"></p>
        </div>
    </div>
</template>

<script>
export default {
    name: "QuizChoice",
    emits: ['select'],
    props: {
        // Choice value
        value: {
            type: [String, Number],
            required: true
        },
        // Display label (can contain HTML for bold text)
        label: {
            type: String,
            required: true
        },
        // Currently selected value (from parent)
        selectedValue: {
            type: [String, Number],
            default: null
        },
        // Font class (optional)
        fontClass: {
            type: String,
            default: ''
        }
    },
    computed: {
        isSelected() {
            return this.selectedValue === this.value;
        },
        formattedLabel() {
            // Replace **text** with <strong>text</strong>
            return this.label.replace(/\*\*(.*?)\*\*/g, '<strong class="text-a-black">$1</strong>');
        }
    },
    methods: {
        selectChoice() {
            this.$emit('select', this.value);
        }
    }
};
</script>
